const DOCUMENT = 'USER_';

const actions = {
  ADD: DOCUMENT + 'ADD',
  CANCEL: DOCUMENT + 'CANCEL',
  CHANGE_PROPERTIES: DOCUMENT + 'CHANGE_PROPERTIES',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CREATE: DOCUMENT + 'CREATE',
  DELETE: DOCUMENT + 'DELETE',
  DELETE_SUCCESS: DOCUMENT + 'DELETE_SUCCESS',
  DISABLE: DOCUMENT + 'DISABLE',
  EDIT: DOCUMENT + 'EDIT',
  ENABLE: DOCUMENT + 'ENABLE',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  RESEND_EMAIL_REQUEST: DOCUMENT + 'RESEND_EMAIL_REQUEST',
  RESEND_EMAIL_START: DOCUMENT + 'RESEND_EMAIL_START',
  RESEND_EMAIL_SUCCESS: DOCUMENT + 'RESEND_EMAIL_SUCCESS',
  RESEND_EMAIL_ERROR: DOCUMENT + 'RESEND_EMAIL_ERROR',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_FAIL: DOCUMENT + 'SAVE_FAIL',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',

  add: data => ({ type: actions.ADD, payload: data }),
  cancel: () => ({ type: actions.CANCEL }),
  changeProperties: data => ({ type: actions.CHANGE_PROPERTIES, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  create: () => ({ type: actions.CREATE }),
  delete: data => ({ type: actions.DELETE, payload: data }),
  deleteSuccess: () => ({ type: actions.DELETE_SUCCESS }),
  disable: data => ({ type: actions.DISABLE, payload: data }),
  edit: data => ({ type: actions.EDIT, payload: data }),
  enable: data => ({ type: actions.ENABLE, payload: data }),
  loadData: data => ({ type: actions.LOAD, payload: { ...data } }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  loadFormData: data => ({ type: actions.LOAD_FORM_DATA, payload: data }),
  resendEmail: data => ({ type: actions.RESEND_EMAIL_REQUEST, payload: data }),
  resendEmailStart: () => ({ type: actions.RESEND_EMAIL_START }),
  resendEmailSuccess: () => ({ type: actions.RESEND_EMAIL_SUCCESS }),
  resendEmailError: () => ({ type: actions.RESEND_EMAIL_ERROR }),
  save: data => ({ type: actions.SAVE, payload: data }),
  saveFail: data => ({ type: actions.SAVE_FAIL, payload: data }),
  saveSuccess: data => ({ type: actions.SAVE_SUCCESS, payload: data }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
};

export default actions;
